<template>
  <div>
    <div :class="[{ show_class: isShowDialog }, 'drawernavigation']">
      <div
        :style="{
          height: '100%',
          'overflow-y': 'auto',
          background: datas.backColor,
          'border-style': datas.borderStyle,
          'border-color': datas.borderColor,
          'border-width': datas.borderLineWeight + 'px',
          'border-radius': datas.borderRadius + 'px',
          'padding-top': datas.paddingTop + 'px',
          'padding-bottom': datas.paddingBottom + 'px',
          'padding-left': datas.paddingLeft + 'px',
          'padding-right': datas.paddingRight + 'px',
          'margin-top': datas.marginTop + 'px',
          'margin-bottom': datas.marginBottom + 'px',
          'margin-left': datas.marginLeft + 'px',
          'margin-right': datas.marginRight + 'px',
        }"
        class="drawer_con"
      >
        <!-- 导航列表 -->
        <section class="nav_list_con">
          <!-- 导航 -->
          <template v-if="datas.imageList.length == 0">
            <div v-for="index in 3" :key="index" class="nav_list_item">
              <div class="img_con">
                <div>
                  <img draggable="false" :src="defaultImg" alt="" />
                </div>
                <div
                  :style="{
                    'font-size': datas.wordSize + 'px',
                    'font-weight': datas.isBold ? 'bold' : 'normal',
                    'font-style': datas.isTilt ? 'italic' : 'normal',
                    'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                    color: datas.wordColor,
                  }"
                >
                  XXX
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- 导航 -->
            <div
              v-for="(item, index) in datas.imageList"
              :key="index"
              class="nav_list_item"
              @click="handleClickImg(item)"
            >
              <div class="img_con">
                <div>
                  <img
                    draggable="false"
                    :src="item.imgUrl ? item.imgUrl : defaultImg"
                    alt=""
                  />
                </div>
                <div
                  :style="{
                    'font-size': datas.wordSize + 'px',
                    'font-weight': datas.isBold ? 'bold' : 'normal',
                    'font-style': datas.isTilt ? 'italic' : 'normal',
                    'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                    color: datas.wordColor,
                  }"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </template>
        </section>
      </div>
      <div class="show_drawer_btn" @click="handleCloseDrawer">
        <i
          :class="[
            {
              'icon-choutizhankai': !isShowDialog,
              'icon-choutishouqi': isShowDialog,
            },
            'iconfont',
          ]"
        ></i>
      </div>
    </div>
    <div
      class="mask_con"
      v-show="isShowDialog"
      @click="handleCloseDrawer"
    ></div>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Drawernavigation",
  props: {
    datas: Object,
  },
  data() {
    return {
      isShowDialog: true,
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },
  created() {},
  methods: {
    handleCloseDrawer() {
      this.isShowDialog = !this.isShowDialog;
    },
    handleClickImg(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.drawernavigation {
  height: 100%;
  position: fixed;
  width: 40%;
  left: -40%;
  top: 0;
  z-index: 999;
  transition: left 0.5s;
  &.show_class {
    left: 0;
  }
  .drawer_con {
    // /* 滚动条 */
    // &::-webkit-scrollbar {
    //   width: 4px;
    // }
    // &::-webkit-scrollbar-thumb {
    //   background: #e1e3e9;
    //   border-radius: 20px;
    // }
  }
  .nav_list_con {
    .nav_list_item {
      display: flex;
      align-items: center;
      margin: 12px 0 24px;
      .img_con {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          margin-right: 20px;
          vertical-align: middle;
        }
      }
    }
  }
}
.mask_con {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.show_drawer_btn {
  position: absolute;
  top: 2px;
  left: 100%;
  background: #fff;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  border-radius: 0 20px 20px 0;
  box-shadow: 5px 2px 10px 0 rgba(0, 0, 0, 0.1);
  .iconfont {
    font-size: 50px;
  }
  // z-index: 1;
}
</style>
